import * as React from 'react';

import logo from '@/assets/vivid_vision_logo.png';
import { Link } from '@/components/Elements';
import { Head } from '@/components/Head';

type LayoutProps = {
  children: React.ReactNode;
  title: string;
  secondary?: React.ReactNode;
};

export const Layout = ({ children, title, secondary }: LayoutProps) => {
  return (
    <>
      <Head title={title} />
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex justify-center">
            <Link className="flex items-center text-white" to="/">
              <img className="h-24 w-auto" src={logo} alt="Workflow" />
            </Link>
          </div>

          {/* <h2 className="mt-3 text-center text-3xl font-extrabold text-gray-900">{title}</h2> */}
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">{children}</div>
        </div>
        {secondary && <div className="p-4 pb-16">{secondary}</div>}
      </div>
      
    </>
  );
};
